import { MenuBackground } from './MenuBackground';
import { getTutorialList } from '../../tutorials/tutorials';
import { t, type Language } from '../../i18n/translations';
import './styles.css';

type MenuView = 'main' | 'tutorials';

type MenuScreenProps = {
    lang: Language;
    view: MenuView;
    onStartSandbox: () => void;
    onOpenTutorials: () => void;
    onBack: () => void;
    onStartTutorial: (id: string) => void;
    showQuitTutorial: boolean;
    onQuitTutorial: () => void;
};

export const MenuScreen = ({
    lang,
    view,
    onStartSandbox,
    onOpenTutorials,
    onBack,
    onStartTutorial,
    showQuitTutorial,
    onQuitTutorial,
}: MenuScreenProps) => {
    const tutorials = getTutorialList(lang);

    return (
        <div className="menu">
            <MenuBackground />
            <div className="menu__panel">
                <div className="menu__title">{t(lang, 'menu.title')}</div>
                {view === 'main' ? (
                    <div className="menu__actions">
                        <button type="button" className="menu__button" onClick={onStartSandbox}>
                            {t(lang, 'menu.startSandbox')}
                        </button>
                        <button type="button" className="menu__button" onClick={onOpenTutorials}>
                            {t(lang, 'menu.tutorials')}
                        </button>
                        {showQuitTutorial ? (
                            <button
                                type="button"
                                className="menu__button menu__button--danger"
                                onClick={onQuitTutorial}
                            >
                                {t(lang, 'menu.quitTutorial')}
                            </button>
                        ) : null}
                    </div>
                ) : (
                    <div className="menu__tutorials">
                        <div className="menu__subtitle">{t(lang, 'menu.pickTutorial')}</div>
                        <div className="menu__tutorial-list">
                            {tutorials.map((tutorial) => (
                                <button
                                    type="button"
                                    key={tutorial.id}
                                    className="menu__tutorial-card"
                                    onClick={() => onStartTutorial(tutorial.id)}
                                >
                                    <div className="menu__tutorial-title">{tutorial.title}</div>
                                    <div className="menu__tutorial-desc">
                                        {tutorial.description}
                                    </div>
                                </button>
                            ))}
                        </div>
                        <button type="button" className="menu__button" onClick={onBack}>
                            {t(lang, 'menu.back')}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
